import notFoundImg from "assets/images/not-found.png";
import MDBox from './MDBox';
import MDTypography from './MDTypography';

const ListingImageCol = ({
    imgUrl,
    name,
    altText = name,
    variant = "standard",
    color = "text",
    className = "listing-image",
    onClick,
    noMaxWidth = false
}) => {
    const handleImageError = (e) => {
        e.target.src = notFoundImg;
    };

    return (
        <MDBox display="flex" alignItems="center" sx={{ gap: 1, flex: 1 }}>
            <img
                src={imgUrl || notFoundImg}
                alt={altText}
                className={className}
                onError={handleImageError}
                onClick={onClick}
                style={{ cursor: onClick ? 'pointer' : 'default' }}
            />
            {name && <MDTypography component="div" variant={variant} color={color} sx={{ wordWrap: 'break-word', whiteSpace: 'normal', maxWidth: noMaxWidth ? 'auto' : '50vw' }}>
                {name}
            </MDTypography>}
        </MDBox>
    );
};

export default ListingImageCol;